// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/varsity_regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/jersey_M54.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: 'ClassicVarsity';
  src: local('ClassicVarsity'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}


@font-face {
  font-family: 'ClassicJersey';
  src: local('ClassicJersey'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

.varsity {
  font-family: 'ClassicVarsity', arial;
}
.jersey {
  font-family: 'ClassicJersey', arial;
}
`, "",{"version":3,"sources":["webpack://./src/styles/fontStyles.css"],"names":[],"mappings":";AACA;EACE,6BAA6B;EAC7B,wFAAoF;AACtF;;;AAGA;EACE,4BAA4B;EAC5B,uFAA8E;AAChF;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC","sourcesContent":["\n@font-face {\n  font-family: 'ClassicVarsity';\n  src: local('ClassicVarsity'), url('../fonts/varsity_regular.ttf') format('truetype');\n}\n\n\n@font-face {\n  font-family: 'ClassicJersey';\n  src: local('ClassicJersey'), url('../fonts/jersey_M54.ttf') format('truetype');\n}\n\n.varsity {\n  font-family: 'ClassicVarsity', arial;\n}\n.jersey {\n  font-family: 'ClassicJersey', arial;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
